/**
 * Specifies Chart Themes
 */
/** @private */
export const axisLabelFont = {
    size: '12px',
    fontWeight: 'Normal',
    color: null,
    fontStyle: 'Normal',
    fontFamily: 'Segoe UI'
};
/** @private */
export const axisTitleFont = {
    size: '14px',
    fontWeight: 'Normal',
    color: null,
    fontStyle: 'Normal',
    fontFamily: 'Segoe UI'
};
/** @private */
export const chartTitleFont = {
    size: '15px',
    fontWeight: '500',
    color: null,
    fontStyle: 'Normal',
    fontFamily: 'Segoe UI'
};
/** @private */
export const chartSubTitleFont = {
    size: '11px',
    fontWeight: '500',
    color: null,
    fontStyle: 'Normal',
    fontFamily: 'Segoe UI'
};
/** @private */
export const crosshairLabelFont = {
    size: '13px',
    fontWeight: 'Normal',
    color: null,
    fontStyle: 'Normal',
    fontFamily: 'Segoe UI'
};
/** @private */
export const tooltipLabelFont = {
    size: '13px',
    fontWeight: 'Normal',
    color: null,
    fontStyle: 'Normal',
    fontFamily: 'Segoe UI'
};
/** @private */
export const legendLabelFont = {
    size: '13px',
    fontWeight: 'Normal',
    color: null,
    fontStyle: 'Normal',
    fontFamily: 'Segoe UI'
};
/** @private */
export const stripLineLabelFont = {
    size: '12px',
    fontWeight: 'Regular',
    color: '#353535',
    fontStyle: 'Normal',
    fontFamily: 'Segoe UI'
};
/** @private */
export const stockEventFont = {
    size: '13px',
    fontWeight: 'Normal',
    color: null,
    fontStyle: 'Normal',
    fontFamily: 'Segoe UI'
};
